export const ADD_TREATMENT = 'ADD_TREATMENT';

export const addTreatment = data => {
    return { type: ADD_TREATMENT, data: data }
};
